import { Currency } from '../../schemas';

export const CURRENCY_CHAR_MAP = {
  EUR: '€',
  GBP: '£',
  USD: '$',
};

export type CurrencyOption = {
  label: string;
  value: string;
};

export const CURRENCY_OPTIONS: CurrencyOption[] = [
  {
    label: CURRENCY_CHAR_MAP[Currency.USD],
    value: Currency.USD,
  },
  {
    label: CURRENCY_CHAR_MAP[Currency.GBP],
    value: Currency.GBP,
  },
  {
    label: CURRENCY_CHAR_MAP[Currency.EUR],
    value: Currency.EUR,
  },
];

export const isAcceptedCurrency = (currency: string): currency is Currency =>
  Currency[currency as keyof typeof Currency] !== undefined;
